import { Card, Select, Row, Col } from "antd";
import { usePicklists } from "components/picklists/PicklistContextProvider";

interface LocationFilterProps {
  selectedRegions?: string[];
  selectedLocations?: string[];
  onRegionsChange: (value: string[] | undefined) => void;
  onLocationsChange: (value: string[] | undefined) => void;
}

const LocationFilter = ({ 
  selectedRegions = [], 
  selectedLocations = [],
  onRegionsChange,
  onLocationsChange
}: LocationFilterProps) => {
  const { regions, locations } = usePicklists();

  const handleRegionChange = (value: string[]) => {
    if (value.includes("all")) {
      if (selectedRegions?.length === regions?.length) {
        onRegionsChange([]);
      } else {
        onRegionsChange(regions?.map(region => region.regionId));
      }
    } else {
      const newSelectedRegions = value.filter(id => id !== "all");
      onRegionsChange(newSelectedRegions);
    }
  };

  const handleLocationChange = (value: string[]) => {
    if (value.includes("all")) {
      if (selectedLocations?.length === locations?.length) {
        onLocationsChange([]);
      } else {
        onLocationsChange(locations?.map(location => `${location.locationId}`));
      }
    } else {
      const newSelectedLocations = value.filter(id => id !== "all");
      onLocationsChange(newSelectedLocations);
    }
  };

  const isAllRegionsSelected = selectedRegions?.length === regions?.length;
  const isAllLocationsSelected = selectedLocations?.length === locations?.length;

  return (
    <Card
      styles={{ body: {padding: "16px"} }} 
      className={`service-filter-card`}>
      <span className="location-filter-title">
        Location
      </span>
      <Row gutter={[8,12]} style={{ marginTop: '10px' }}>
        <Col xs={24} sm={12}>
          <label htmlFor="region" className="input-label">
            Region
          </label>
          <Select
            id="region"
            mode="multiple"
            variant="borderless"
            value={
              isAllRegionsSelected
                ? regions?.map(region => region.regionId)
                : selectedRegions
            }
            onChange={handleRegionChange}
            allowClear
            className="location-filter-select"
            placeholder="Please select region"
            maxTagCount="responsive"
            showSearch
            filterOption={(input, option) =>
              option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            <Select.Option key="all" value="all">
              All Regions
            </Select.Option>
            {regions?.map(region => (
              <Select.Option key={region.regionId} value={region.regionId}>
                {region.regionName}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={12}>
          <label htmlFor="location" className="input-label">
            Location
          </label>
          <Select
            id="location"
            mode="multiple"
            variant="borderless"
            allowClear
            value={
              isAllLocationsSelected
                ? locations?.map(location => `${location.locationId}`)
                : selectedLocations
            }
            onChange={handleLocationChange}
            className="location-filter-select"
            placeholder="Please select location"
            maxTagCount="responsive"
            showSearch
            filterOption={(input, option) =>
              option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            <Select.Option key="all" value="all">
              All Locations
            </Select.Option>
            {locations?.sort((a, b) => a.locationName.localeCompare(b.locationName)).map(location => (
              <Select.Option key={location.locationId} value={`${location.locationId}`}>
                {location.locationName}
              </Select.Option>
            ))}
          </Select>
        </Col>
      </Row>
    </Card>
  );
};

export default LocationFilter;
